module.exports = __webpack_public_path__ + "img/lily_pads.3fdf5411.jpg";